import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/appGallery.svg';

export const IconAppGallery = createIconComponent(Icon);
